module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper conversation-container",
    staticStyle: {
      "margin-left": "0px !important"
    }
  }, [_c('div', {
    staticClass: "stage-panel-header"
  }, [_c('div', {
    staticClass: "stage-panel-header__text"
  }, [_c('span', {
    staticClass: "stage-panel-header__eyebrow"
  }, [_vm._v(_vm._s(_vm.isStartStage ? 'Start stage' : 'Editing stage'))]), _vm._v(" "), _c('span', {
    staticClass: "stage-panel-header__name",
    attrs: {
      "title": _vm.stageToEdit && _vm.stageToEdit.stageName
    }
  }, [_vm._v(_vm._s(_vm.isStartStage ? _vm.conversationType + ' details' : (_vm.stageToEdit && _vm.stageToEdit.stageName)))])])]), _vm._v(" "), _c('div', {
    staticClass: "stage-panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [(_vm.stageToEdit.stageName === 'uninitialized') ? _c('div', {
    staticClass: "stage-panel-card"
  }, [_c('div', {
    staticClass: "stage-panel-card__title"
  }, [_vm._v(_vm._s(_vm.conversationType) + " settings")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.name),
      expression: "config.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": _vm.conversationType + ' name',
      "disabled": _vm.isEdit || _vm.conversationName
    },
    domProps: {
      "value": (_vm.config.name)
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.config.name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter name.")]) : _vm._e(), _vm._v(" "), (_vm.submitted && !_vm.$v.config.name.conversationNameRegex) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v(" The name can only contain underscore, dash and alphanumeric characters.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), (_vm.isJourneyConversation) ? _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "disabled": _vm.isEdit
    },
    model: {
      value: (_vm.config.type),
      callback: function($$v) {
        _vm.$set(_vm.config, "type", $$v)
      },
      expression: "config.type"
    }
  }, [_c('option', {
    attrs: {
      "value": "journey"
    }
  }, [_vm._v("Journey")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "journeyReminder"
    }
  }, [_vm._v("Journey of Reminder")])]) : _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "disabled": _vm.isEdit
    },
    model: {
      value: (_vm.config.type),
      callback: function($$v) {
        _vm.$set(_vm.config, "type", $$v)
      },
      expression: "config.type"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select app type--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "screening"
    }
  }, [_vm._v("Screening")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nonscreening"
    }
  }, [_vm._v("Non Screening")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "scoredresponse"
    }
  }, [_vm._v("Scored Response")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "others"
    }
  }, [_vm._v("Others")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flex-container"
  }, [_c('div', {
    staticClass: "form-group flex-item"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.description),
      expression: "config.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "id": "description",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.config.description)
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group flex-item"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Topic/Context for NLP")]), _vm._v(" "), _c('treeselect', {
    attrs: {
      "id": "topic",
      "placeholder": "--Choose NLP Topic--",
      "multiple": false,
      "options": _vm.nlpTopicList
    },
    model: {
      value: (_vm.config.topic_id),
      callback: function($$v) {
        _vm.$set(_vm.config, "topic_id", $$v)
      },
      expression: "config.topic_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10"
  }, [_c('label', {
    staticClass: "checkbox-inline referral-check-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isReferralApp),
      expression: "isReferralApp"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isReferralApp) ? _vm._i(_vm.isReferralApp, null) > -1 : (_vm.isReferralApp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isReferralApp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isReferralApp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isReferralApp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isReferralApp = $$c
        }
      }
    }
  }), _vm._v("I am responsible for referrals\n                ")])])])])]), _vm._v(" "), _c('conversation-meta-data', {
    ref: "conversationMetadata",
    attrs: {
      "metaData": _vm.metaData,
      "countryAndLanguages": _vm.countryAndLanguages
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('app-new-stage', {
    ref: "selectedStage",
    attrs: {
      "isJourneyStage": _vm.isJourneyConversation ? true : false,
      "stageDetails": _vm.stageToEdit,
      "allApps": _vm.formattedAllApps,
      "embeddedApps": _vm.formattedEmbeddedApps,
      "screeningMethods": _vm.screeningMethods,
      "isScreening": _vm.config.type === 'screening',
      "conversationType": _vm.config.type,
      "currentConvo": _vm.config,
      "filteredApps": _vm.formattedFilteredApps,
      "filteredAppsForConvos": _vm.filteredAppsForConvos,
      "allConversations": _vm.allConversations,
      "allMethods": _vm.methodList,
      "functions": _vm.functionList,
      "metaData": _vm.metaData,
      "countryAndLanguages": _vm.countryAndLanguages
    },
    on: {
      "stageReady": function($event) {
        return _vm.$emit('stageReady')
      },
      "addStage": _vm.addStage,
      "replace": _vm.replaceStage,
      "getAllApps": _vm.getAllApps
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "stage-panel-footer"
  }, [_vm._l((_vm.missingStages.filter(function (item) { return _vm.stageToEdit.stageName === item.stage; })), function(msg, index) {
    return _c('div', {
      key: index,
      staticClass: "stage-panel-warning"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-triangle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(msg.msgSet) + ": " + _vm._s(msg.missingLang.join(', ')) + " translation(s) missing\n    ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "stage-panel-actions"
  }, [_c('button', {
    staticClass: "btn btn-default stage-panel-btn",
    attrs: {
      "disabled": !_vm.actionable,
      "type": "button",
      "title": 'Validate ' + _vm.conversationType + ' should \nonly be clicked at the end  \nonce you have completed \nadding ' + _vm.conversationType.toLowerCase() + ' details'
    },
    on: {
      "click": function($event) {
        return _vm.saveStage(false, undefined, true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validate & Save " + _vm._s(_vm.conversationType) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary stage-panel-btn stage-panel-btn--primary",
    attrs: {
      "disabled": !_vm.actionable,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveStage(false, undefined)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Save Stage\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "stage-panel-actions__divider",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn stage-panel-btn stage-panel-btn--release",
    attrs: {
      "type": "button",
      "title": 'Replaces the live ' + _vm.conversationType.toLowerCase() + ' on production in every instance'
    },
    on: {
      "click": _vm.handleDeployClick
    }
  }, [_c('i', {
    staticClass: "fa fa-rocket",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Release to Production\n      ")])])], 2), _vm._v(" "), (_vm.showConfirmMessage) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "ConversationCopyAlert"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "200PX",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Alert")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("You are about to overwrite an existing " + _vm._s(_vm.conversationType.toLowerCase()) + " with name "), _c('b', [_vm._v(_vm._s(_vm.config.name))]), _vm._v(" on "), _c('b', [_vm._v(_vm._s(_vm.instanceWhereSameNameExist))]), _vm._v(". All the message sets will also be override. Do you want to continue?")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.overrideConvNoClick
    }
  }, [_vm._v("No, I’ll rename it")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.overrideConvYesClick
    }
  }, [_vm._v("Yes, copy & overwrite")])])])])])]) : _vm._e(), _vm._v(" "), ((!_vm.showConfirmMessage) && _vm.showWarningMessage) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Warning")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("There are some conversations/keyword linked with the app which you are trying to release. Please make sure to perform copy below apps in respective instance(s).")]), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red"
    }, [_vm._v("Are you sure you want to proceed without these?")]), _vm._v(" "), _c('div', {
      staticClass: "copy-warning-app-container"
    }, _vm._l((_vm.connectedAppDataForSync), function(data) {
      return _c('div', {
        key: data.instanceName
      }, [(data.appsNotPresent.length || data.appsPresentButNeverDeployed.length || data.keywordsNotPresent.length) ? _c('div', [_c('div', {
        staticStyle: {
          "font-weight": "bold",
          "margin-top": "15px"
        }
      }, [_vm._v(_vm._s(data.instanceName) + ": ")]), _vm._v(" "), (data.appsPresentButNeverDeployed.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                    Conversation(s) present but never deployed:\n                    "), _c('ul', _vm._l((data.appsPresentButNeverDeployed), function(app) {
        return _c('li', {
          key: app
        }, [_vm._v("\n                        " + _vm._s(app) + "\n                      ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (data.appsNotPresent.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                    Conversation(s) not present:\n                    "), _c('ul', _vm._l((data.appsNotPresent), function(app) {
        return _c('li', {
          key: app
        }, [_vm._v("\n                        " + _vm._s(app) + "\n                      ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (data.keywordsNotPresent.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                      Keyword(s) not present:\n                    "), _c('ul', _vm._l((data.keywordsNotPresent), function(keyword) {
        return _c('li', {
          key: keyword
        }, [_vm._v("\n                        " + _vm._s(keyword) + "\n                      ")])
      }), 0)]) : _vm._e(), _vm._v(" "), (data.messageTemplatesNotPresent.length) ? _c('div', {
        staticClass: "copy-warning-text-div"
      }, [_vm._v("\n                      Message Template(s) not present:\n                    "), _c('ul', _vm._l((data.messageTemplatesNotPresent), function(template) {
        return _c('li', {
          key: template
        }, [_vm._v("\n                        " + _vm._s(template) + "\n                      ")])
      }), 0)]) : _vm._e()]) : _vm._e()])
    }), 0)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.CopyConversationWarningNoClick
    }
  }, [_vm._v("No, let me check the conversation")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyConversationWarningYesClick
    }
  }, [_vm._v("Yes, proceed with it")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showTranslationMissingMessage) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Warning")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("Below are the stages missing mentioned translations:")]), _vm._v(" "), _c('div', {
      staticClass: "copy-warning-app-container"
    }, [_c('table', {
      attrs: {
        "width": "100%"
      }
    }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.missingStages), function(item, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(item.stage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.msgSet))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.missingLang.join(',  ')))])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v("Do you want to proceed with current configuration?")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.translationMissingWarningNoClick
    }
  }, [_vm._v("No, let me check the conversation")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.translationMissingWarningYesClick
    }
  }, [_vm._v("Yes, proceed with it")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.showEmptyMessageSetError) ? _c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "max-width": "800px",
      "height": "max-content"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Error")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_vm._t("body", function() {
    return [_c('div', [_vm._v("Below is the list of messages with no translation for this stage:")]), _vm._v(" "), _c('div', {
      staticClass: "copy-warning-app-container"
    }, [_vm._v("\n              " + _vm._s(_vm.emptyMessageSets.join(', ')) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "warning-text-red",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v("Please add at least one language translation for these messages, or remove them if you don't want them shown to users.")])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.emptyMessageSetErrorOkClick
    }
  }, [_vm._v("Ok, let me check")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.processing) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Stage name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Missing Translation(s)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4a83e48f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/conversationPanel.vue
// module id = e4M0
// module chunks = 1